import React from 'react';

const Testimonials = () => {
  return (
    <div style={{ margin: '50px auto', display: 'block', textAlign: 'center' }}>
      {/* Empty div for testimonials */}
    </div>
  );
};

export default Testimonials;
